const dialogInjectionKey = Symbol("dialogInjectionKey");
const DEFAULT_DIALOG_TRANSITION = "dialog-fade";

export { DEFAULT_DIALOG_TRANSITION, dialogInjectionKey };
//# sourceMappingURL=constants.mjs.map
